import { Datepicker } from './Datepicker';

const CustomDatePicker = (props) => {
  return <Datepicker {...props} />;
};
export default CustomDatePicker;
